import config from '../../../Config'
import { useContext, useState, useEffect } from 'react';
import utils from '../../../utils';
import { Modal, Button, Select } from 'antd';
import { ReactBingmaps } from 'react-bingmaps';
import axios from "axios";
import { useTranslation } from 'react-i18next';

function MapLocationGetter({show, onCancel, onOK, centerPoint}) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);

    const [location, setLocation] = useState({});
    const [pushPins, setPushPins] = useState([]);
    const [addressSelectOptions, setAddressSelectOptions] = useState([])
    const [center, setCenter] = useState([])
    const [searchValue, setSearchValue] = useState('');
    const [key, setKey] = useState(0); // 用于强制重新渲染组件


    useEffect(() => {
        setKey(prevKey => prevKey + 1); // 更改 key 强制 ReactBingmaps 重新加载
    }, [show]);    

    useEffect(() =>{
        if (isNaN(centerPoint.Longitude) || isNaN(centerPoint.Latitude)) {
            setPushPins([]);
            
        } else {
            const lt =  [centerPoint.Latitude, centerPoint.Longitude]
            setPushPins([{
                location: lt
            }])
            setCenter(lt)
        }
        setLocation({Longitude: isNaN(centerPoint.Longitude) ? undefined : parseFloat(centerPoint.Longitude), Latitude: isNaN(centerPoint.Latitude) ? undefined : parseFloat(centerPoint.Latitude)})
    }, [centerPoint])

    useEffect(() => {
        let isMounted = true;
        const timer = setTimeout(() => {
            if (searchValue === '') {
                return;
            }
            const url = `https://dev.virtualearth.net/REST/v1/Locations?query=${searchValue}&key=${config.bingMapKey}`;
            const pins = [];
            const addresses = [];
            axios.get(url).then(response => {
                if (!isMounted) return;
                const results = response.data.resourceSets[0].resources;
                for (let i = 0; i < results.length; i++) {
                    const location = [results[i].point.coordinates[0], results[i].point.coordinates[1]];
                    pins.push({
                        location: location,
                        name: (i + 1) + ': ' + results[i].name,
                        option: {
                            text: i + 1 + ''
                        }
                    });
                    addresses.push({
                        name: (i + 1) + ': ' + results[i].name,
                        location: location,
                    })
                }
                setCenter(pins[0].location)
                setPushPins(pins);
            }).catch(err => {
                if (isMounted) {
                    console.log(err)
                    setTip({ open: true, severity: "error", msg: t("Failed to fetch location data") });
                }
            });
        }, 300);

        return () => {
            isMounted = false;
            clearTimeout(timer);
        };
    }, [searchValue, setTip, t]);

    const handleCancle = () => {
        onCancel();
    }

    const handleOK = () => {
        if (location.Latitude !== undefined && location.Longitude !== undefined) {
            onOK(location)
            return;
        }

        setTip({ open: true, severity: "warning", msg: t("No latitude and longitude were selected") });
    }

    const handleMapClick = (e) => {
        setPushPins([{
            location: [e.latitude, e.longitude],
        }]);

        setLocation({
            Longitude: e.longitude,
            Latitude: e.latitude,
        });
    }

    const handleSearchAddress = (value) => {
        setSearchValue(value);
    }

    const handleSelectAddress = (value) => {
        const index = pushPins.findIndex(item => item.name === value);
        const pin = pushPins[index]
        setPushPins([{
            location: pin.location
        }])
        setCenter(pin.location)
        setLocation({
            Longitude: pin.location[1],
            Latitude: pin.location[0],
        });
    }

    return (<Modal
        title={t("GPS Location")}
        visible={show}
        cancelText={t("Cancel")}
        okText={t("OK")}
        mask={true}
        maskClosable={false}
        width={600}
        onCancel={handleCancle}
        onOk={handleOK}
        footer={[
            <Button key="Cancel" onClick={handleCancle}>{t("Cancel")}</Button>,
            <Button key="OK" type="primary" onClick={handleOK}>{t("OK")}</Button>
        ]}
    >
        <div style={{
            display: "flex",
            flexDirection: "column"
        }}>
            <div style={{
                padding: "5px",
            }}>
                <Select
                    showSearch
                    placeholder={t("Enter Address")}
                    defaultActiveFirstOption={false}
                    showArrow={false}
                    filterOption={false}
                    onSearch={handleSearchAddress}
                    onSelect={handleSelectAddress}
                    style={{width: '100%'}}
                >{ pushPins.map((item, index) => {
                    return (
                        <Select.Option key={index} value={item.name}>{item.name}</Select.Option>
                    );
                })}</Select>
            </div>
            <div style={{
                padding: "5px",
            }}>
                {t("Location")}:({location.Longitude ? location.Longitude.toFixed(6) : "-"}, {location.Latitude ? location.Latitude.toFixed(6) : "-"})
            </div>
            <div style={{
                width: "100%",
                height: "400px",
            }}>
                <ReactBingmaps
                    key={key}
                    id="bingmap3"
                    bingmapKey={config.bingMapKey}
                    pushPins={pushPins.length!=0 ? pushPins : []}
                    center={center.length!=0 ? center : []}
                    zoom={5}
                    getLocation={{
                        addHandler: "click",
                        callback: handleMapClick,
                    }}
                ></ReactBingmaps>
            </div>
        </div>
    </Modal>);
}

export default MapLocationGetter;